import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { get as _get } from 'lodash';
import { Observable, of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

import { fromRouterActions } from '@amfam/shared/utility/navigation';

import * as fromRoot from '../../../core/store';
import * as replaceVehiclePolicyActions from '../../../core/store/replace-vehicle-policy/replace-vehicle-policy.actions';
import { ReplaceVehicleReviewComponent } from '../../replace-vehicle/replace-vehicle-review/replace-vehicle-review.component';

@Injectable()
export class ReplaceVehicleLookInGuard {
  constructor(private store: Store<fromRoot.RootState>) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.store.select(fromRoot.getReplaceVehiclePolicyState).pipe(
      take(1),
      switchMap(policyState => {
        if (policyState) {
          if (_get(policyState, 'vehicleId') === _get(next, 'params.id')) {
            return of(true);
          }
        }
        this.store.dispatch(
          fromRouterActions.Go({
            path: ['/policies/replace-vehicle']
          })
        );
        return of(false);
      })
    );
  }

  canDeactivate(
    component: ReplaceVehicleReviewComponent,
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): any {
    if (nextState.url.toString().indexOf('/policies/replace-vehicle') === -1) {
      this.store.dispatch(new replaceVehiclePolicyActions.ReplaceVehiclePolicySelectClearAction());
    }
    return true;
  }
}
